import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { API } from "@/lib/api";
import { useApiList } from "./useApiList";
import { SURFACES, STYLES } from "@/components/ai/options";

export const useAiStudio = (onQuote) => {
  const [fields, setFields] = useState({ idea: "", surface: "mur_interieur", style: "neon_street", word: "" });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const gallery = useApiList("/artworks");
  const update = (field, value) => setFields((current) => ({ ...current, [field]: value }));
  const generate = async () => {
    if (fields.idea.trim().length < 3) { toast.error("Décris ton idée en quelques mots d'abord"); return; }
    setLoading(true);
    setError(null);
    const project = { ...fields, idea: fields.idea.trim(), word: fields.word.trim() };
    try {
      const { data } = await axios.post(`${API}/ai/imagine`, project, { timeout: 180000 });
      setResult({ ...data, project });
      toast.success("Ton chef-d'œuvre est prêt !");
      gallery.reload();
    } catch (err) {
      const detail = err.response?.data?.detail;
      const message = typeof detail === "string" ? detail : "La génération a échoué. Réessaie dans un instant";
      setError(message);
      toast.error(message);
    } finally { setLoading(false); }
  };
  const askSketch = () => {
    if (!result) return;
    const { idea, surface, style, word } = result.project;
    const surfaceLabel = SURFACES.find(([key]) => key === surface)?.[1] || surface;
    const styleLabel = STYLES.find(([key]) => key === style)?.[1] || style;
    onQuote({ id: "graffiti", requestType: "croquis" }, `Chef-d'œuvre imaginé par l'IA — Idée : ${idea} | Surface : ${surfaceLabel} | Style : ${styleLabel}${word ? ` | Mot : ${word}` : ""}`);
  };
  return { fields, update, loading, result, error, gallery, generate, askSketch };
};